import axios from '@/axios';
import _ from 'lodash';
//import { sync } from 'vuex-router-sync';

//sync(store, router);

let accessToken = localStorage.accessToken;
axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;

const cacheExpiry = 0 * 1000; // for development, no cache at all 

export default {

  namespaced: true,

  actions: {

    async teamList ( {state, commit, rootState}, payload ) {
      let notExpired = (await state.cache_expiry) > (new Date);
      let notEmpty = !_.isEmpty(await state.teams);

      //var organization_id=state.user.id;
      var organization_id=rootState.user.current_organization;

      if (notExpired && notEmpty) return;

      try {
        let res = await axios.get('/organization/'+organization_id+'/member');
        commit('UPDATE_FORMS', res.data.data);
        //TODO: split by organization ?
      } catch (e) {
        throw e;
      }
    },

    async createForm( {commit}, payload ) {
      try {
        let res = await axios.post('/form', payload);
        commit('CREATE_FORM', res);
      } catch (e) {
        throw e;
      }
    },

    async updateForm( {commit}, payload ) {
      try {
        let res = await axios.patch('/form', payload);
        commit('UPDATE_FORM', res);
      } catch (e) {
        throw e;
      }
    },

    async removeForm( {commit}, form_id ) {
      try {
        //let res = await axios.delete('/form', payload);
        console.log(`Deleting form #${form_id}`);
        commit('REMOVE_FORM', form_id);
      } catch (e) {
        throw e;
      }
    },

    async removeForms( {commit}, form_ids ) {
      try {
        //let res = await axios.delete('/form', payload);
        console.log(`Deleting form #${form_ids.join(', ')}`);
        commit('REMOVE_FORMS', form_ids);
      } catch (e) {
        throw e;
      }
    },

    async getSingleForm( {commit, state}, form_id ) {
      try {
        let res = await axios.get(`/form/${form_id}`);
        commit('SET_CURRENT_FORM', res.data.data);
      } catch (e) {
        throw(e);
      }

    },

    async getEditForm( {commit, state}, form_id ) {
      try {
        let res = await axios.get(`/form/${form_id}`);
        commit('SET_CURRENT_FORM', res.data.data);
      } catch (e) {
        throw(e);
      }

    },
  },

  getters: {

    layoutNames () {
      return [ 'Dropdown', 'Grid', 'Card' ];
    }, 

  },

  mutations: {

    UPDATE_FORMS (state, payload) {
      state.teams = payload;
      state.cache_expiry = new Date((new Date) + cacheExpiry);
    },

    UPDATE_FORM (state, payload) {

      state.cache_expiry = new Date((new Date) + cacheExpiry);
    },

    CREATE_FORM (state, payload) {

      state.cache_expiry = new Date((new Date) + cacheExpiry);
    },

    REMOVE_FORM (state, form_id) {
      state.teams = state.forms.filter(x => x.id !== form_id);
      state.cache_expiry = new Date((new Date) + cacheExpiry);
    },

    REMOVE_FORMS (state, form_ids) {
      state.teams = state.forms.filter(x => form_ids.indexOf(x.id) < 0);
      state.cache_expiry = new Date((new Date) + cacheExpiry);
    },

    SET_CURRENT_FORM(state, payload) {
      state.current_team = payload;
    },

  },

  state: {
    teamList: [],
    teams:[],
    cache_expiry: new Date(),
    current_team: {},
  }
}
